'use strict'

const API_BASE = 'https://tossp.yoooooo.com/index.php/index/product_direction_image/'

module.exports = {
  warehouseDetail: API_BASE + 'warehouseDetail',
  warehouseSave: API_BASE + 'warehouseSave',
  productDetail: API_BASE + 'productDetail'
}



// WEBPACK FOOTER //
// ./src/api/productDirectionImage.js